/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-zns-templates';

export const EntityZNSTemplateApi = {
  find: async (option: any) => {
    const { ...param } = option;

    let url = `${pathname}/entity`;
    const query = serialize(param);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
